import { Inline } from '@atlaskit/primitives';
import { FunctionComponent } from 'react';

interface IconWithContentProps {
  icon: React.ReactNode;
  text: React.ReactNode;
}

const IconWithContent: FunctionComponent<IconWithContentProps> = ({
  icon,
  text,
}) => {
  return (
    <Inline space="space.200" alignBlock="center">
      {icon}
      <span>{text}</span>
    </Inline>
  );
};

export default IconWithContent;
